import {SectionType} from '../graphql/generated/types';

export const PAGEWEB_LAYOUT_STATE_NAME = 'pagewebLayout';

export const SECTION_WITH_PAGING_LIST = [
  SectionType.LandingDayOfWeek,
  SectionType.LandingRanking,
  SectionType.LandingGenre,
  SectionType.LandingEvent,
  SectionType.LandingFreeSeries,
  SectionType.LandingOriginal,
  SectionType.LandingTodayUp,
];
